import script from "./CardDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CardDialog.vue?vue&type=script&setup=true&lang=js"

import "./CardDialog.vue?vue&type=style&index=0&id=c970cd96&lang=css"

const __exports__ = script;

export default __exports__